import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { UpdateTextContent } from '../models/text-content.model';

@Injectable({
  providedIn: 'root',
})
export class TextContentService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    slug?: string,
    description?: string
  ) {
    let params = '';

    if (slug) params += `&slug=${slug}`;
    if (description) params += `&description=${description}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/text-contents?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/text-contents/' + id
    );
  }

  update(textContentId: string, data: UpdateTextContent) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/text-contents/${textContentId}/content`,
      data
    );
  }
}
